import type { SYSAction } from "../../../../_ovlclient/src"
import { TableRefresh } from "../../../../_ovlclient/src/library/table/tableapi"
import { SYSSeqId } from "../../../src/global/globalapi"

const HookScreenRefresh: SYSAction = async (_) => {
  await TableRefresh("SYSTranslation")
}

const HookScreenNavigateIn: SYSAction = async (_, { global }) => {
  await TableRefresh("SYSTranslation", {
    preferCache: true,
  })
}

export let SYSTranslation = {
  hooks: { HookScreenNavigateIn, HookScreenRefresh },
}
